import { render } from "./ListTransmission.vue?vue&type=template&id=e5c38ba2"
import script from "./ListTransmission.vue?vue&type=script&lang=js"
export * from "./ListTransmission.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__